import { render, staticRenderFns } from "./ProductGroupListEdit.vue?vue&type=template&id=28837df9&scoped=true&"
import script from "./ProductGroupListEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupListEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupListEdit.vue?vue&type=style&index=0&id=28837df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28837df9",
  null
  
)

export default component.exports